import html from "../assets/svg/skills/html.svg";

import css from "../assets/svg/skills/css.svg";
import javascript from "../assets/svg/skills/javascript.svg";
import react from "../assets/svg/skills/react.svg";
import bootstrap from "../assets/svg/skills/bootstrap.svg";
import mongoDB from "../assets/svg/skills/mongoDB.svg";
import c from "../assets/svg/skills/c.svg";
import aws from "../assets/svg/skills/aws.svg";
import firebase from "../assets/svg/skills/firebase.svg";
import git from "../assets/svg/skills/git.svg";
import materialui from "../assets/svg/skills/materialui.svg";
import wordpress from "../assets/svg/skills/wordpress.svg";
import nodejs from "../assets/svg/skills/nodejs.svg";
import ExpressJS from "../assets/svg/skills/expressjsss.svg";
import figma from "../assets/svg/skills/figma.svg";
import microsoftoffice from "../assets/svg/skills/microsoftoffice.svg";
import picsart from "../assets/svg/skills/picsart.svg";
import canva from "../assets/svg/skills/canva.svg";
import chakra from "../assets/svg/skills/chakra.jpg"
import redux from "../assets/svg/skills/redux.png"

export const skillsImage = (skill) => {
  const skillID = skill.toLowerCase();
  switch (skillID) {
    case "html":
      return html;
    case "css":
      return css;
    case "javascript":
      return javascript;
    case "react":
      return react;
    case "bootstrap":
      return bootstrap;
    case "nodejs":
      return nodejs;
    case "mongodb":
      return mongoDB;
    case "c":
      return c;
    case ExpressJS:
      return "ExpressJS";
    case "aws":
      return aws;
    case "firebase":
      return firebase;
    case "git":
      return git;
    case "materialui":
      return materialui;
    case "wordpress":
      return wordpress;
    case "figma":
      return figma;
    case "microsoft office":
      return microsoftoffice;
    case "picsart":
      return picsart;
    case "canva":
      return canva;
      case "chakra":
      return chakra;
      case "redux":
        return redux;
    default:
      break;
  }
};
